import { buildCliAutoApprovedPermissionRpcResult } from '@buildautomaton/types';
import type { AcpClientOptions } from '../clients/acp-client.js';
import type { AcpBridgeHooksOptions } from './acp-bridge-types.js';
import { errorMessage } from '../../../error-message.js';

export function createBridgeOnRequest(opts: AcpBridgeHooksOptions): NonNullable<AcpClientOptions['onRequest']> {
  const { resolveRouting, getSendRequest, log, getAutoApproveAcpPermissions, resolveAcpPermissionRequest, nextTranscriptStreamSeq } =
    opts;

  return (request) => {
    const routing = resolveRouting();
    const runId = routing?.runId;
    const sessionId = routing?.sessionId;
    const sendReq = getSendRequest();
    if (!runId || !sendReq) return;
    const kind =
      request.method === 'cursor/create_plan'
        ? 'plan'
        : request.method === 'session/request_permission'
          ? 'permission'
          : 'question';
    const sessionUpdate =
      request.method === 'cursor/create_plan'
        ? 'plan'
        : request.method === 'session/request_permission'
          ? 'permission'
          : 'question';

    if (
      request.method === 'session/request_permission' &&
      getAutoApproveAcpPermissions() &&
      resolveAcpPermissionRequest
    ) {
      const params =
        request.params != null && typeof request.params === 'object' && !Array.isArray(request.params)
          ? (request.params as Record<string, unknown>)
          : {};
      const auto = buildCliAutoApprovedPermissionRpcResult(params);
      if (auto != null) {
        try {
          resolveAcpPermissionRequest(request.requestId, auto);
          log(
            `[Bridge service] CLI dangerous mode: auto-approved permission requestId=${request.requestId} runId=${runId}`,
          );
          return;
        } catch (err) {
          log(
            `[Bridge service] CLI dangerous mode: auto-approve failed (${errorMessage(err)}); forwarding permission`,
          );
        }
      }
      log(
        `[Bridge service] CLI dangerous mode: no allow option to auto-select; forwarding permission requestId=${request.requestId}`,
      );
    }

    try {
      const transcriptStreamSeq = nextTranscriptStreamSeq?.(runId);
      sendReq({
        type: 'session_update',
        ...(sessionId ? { sessionId } : {}),
        runId,
        kind,
        /** Top-level for bridge DO jobs / web push when `payload` is E2EE-encrypted. */
        requestId: request.requestId,
        payload: {
          sessionUpdate,
          requestId: request.requestId,
          method: request.method,
          params: request.params,
        },
        ...(transcriptStreamSeq != null ? { transcriptStreamSeq } : {}),
      });
    } catch (err) {
      log(
        `[Bridge service] Agent protocol request forward failed (${request.method}): ${errorMessage(err)}`,
      );
    }
  };
}
